import { useAppSelector } from "../../../services/hooks/useReduxHooks";
import { GraphicTypeEnum } from "../../../services/redux/types/CartLoyaltyV2Types";
import { MAIN_OFFER_TYPE } from "../../../utils/enums";
import Offer from "../../../utils/OfferClass/Offer/Offer";
import { BundleOfferImages } from "../../screens/S-Cart/ItemList/bundleItem/bundleItemImage";
import { TwistIcon } from "../Icons/Icons";
import {
  FreeItemIcon,
  MileStone,
  OfferIcon,
  offerIconPath101PX,
} from "../Icons/loyalty.icons";
import { PImage } from "../../shared/PImage/PImage";
import styles from "./GeneralOfferIcon.module.scss";

export const GeneralOfferIcon = (props: {
  offer?: Offer;
  sliderStyle?: boolean;
  backgroundIconColor?: "primary" | "loyalty";
  largeIcons?: boolean;
  twist?: boolean;
  width?: number;
  fontStyle?: React.CSSProperties;
}) => {
  const { offer } = props;

  if (offer && offer.isMultiplierOffer()) {
    return (
      <div className={props.sliderStyle ? styles.slider : ""}>
        <div
          className={`${styles.multiplier_icon} ${
            props.largeIcons && styles.large
          }`}
          style={{ width: `${props.width}px`, height: `${props.width}px` }}
        >
          <span style={props.fontStyle}>
            {offer.uiDetails?.graphic?.value[0]}
          </span>
          <MileStone hasFullWidth={!!props.width} />
        </div>
      </div>
    );
  }
  const showCircularItems =
    offer &&
    ((offer.uiDetails?.graphic?.type === GraphicTypeEnum.IMAGE &&
      offer.uiDetails?.graphic?.value.length > 1 &&
      offer.offerType === MAIN_OFFER_TYPE.BUNDLE) ||
      offer.offerType === MAIN_OFFER_TYPE.BOGO);

  const graphic =
    offer &&
    (offer.isBogoOffer() ? offer.uiDetails?.icon : offer.uiDetails?.graphic);

  return (
    <div className={props.sliderStyle ? styles.slider : ""}>
      <div
        className={`${styles.offer_label} ${props.largeIcons && styles.large}`}
        style={{ width: `${props.width}px`, height: `${props.width}px` }}
      >
        <div
          className={`${styles.flip_animation} ${
            props.twist && !showCircularItems && styles.animate
          }`}
        >
          <div
            className={`${
              props.twist && !showCircularItems ? styles.front : styles.center
            }`}
          >
            {!showCircularItems ? (
              <>
                <div
                  className={` ${styles.offer_label_background} ${
                    props.backgroundIconColor &&
                    styles[props.backgroundIconColor]
                  } ${props.largeIcons && styles.large}`}
                >
                  <OfferIcon />
                </div>
                <div
                  className={`${styles.offer_svg} ${
                    props.largeIcons && styles.large
                  }`}
                >
                  <MapGeneralOfferIcon
                    graphic={
                      graphic || {
                        type: GraphicTypeEnum.ICON,
                        value: ["gift"],
                      }
                    }
                    largeIcons={props.largeIcons}
                  />
                </div>
              </>
            ) : (
              <BundleOfferImages
                large={props.largeIcons}
                graphics={
                  graphic && [
                    {
                      type: graphic.type,
                      value: graphic.value[0],
                    },
                  ]
                }
                transparentBg={true}
              />
            )}
          </div>

          <div className={`${styles.back}`}>
            <div
              className={` ${styles.offer_label_background} ${styles.twist} ${
                props.largeIcons && styles.large
              }`}
            >
              <OfferIcon />
            </div>
            <div
              className={`${styles.offer_svg} ${
                props.largeIcons && styles.large_twist
              } ${styles.twist} `}
            >
              <TwistIcon />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const MapGeneralOfferIcon = (props: {
  graphic: {
    type: GraphicTypeEnum;
    value: string[] | string;
  };
  largeIcons?: boolean;
}) => {
  const { restaurantInfo } = useAppSelector((state) => state.config);

  const singleValue =
    props.graphic?.value instanceof Array
      ? props.graphic?.value[0]
      : props.graphic?.value;

  const mapOfferUi = () => {
    switch (props.graphic?.type) {
      case GraphicTypeEnum.IMAGE:
        return !props.largeIcons ? (
          <FreeItemIcon />
        ) : (
          <div
            className={styles.img_container}
            style={{ clipPath: `path("${offerIconPath101PX}")` }}
          >
            <PImage
              src={singleValue}
              alt={""}
              fill
              style={{ objectFit: "cover", objectPosition: "center" }}
              className={styles.img}
            />
          </div>
        );
      case GraphicTypeEnum.ICON:
        return Offer.mapOfferIcon(
          singleValue,
          restaurantInfo?.config?.alternatePercentageIcon
        );
      case GraphicTypeEnum.TEXT:
        return <span>{singleValue}</span>;
      default:
        return null;
    }
  };

  return mapOfferUi();
};
